import React from 'react';

import '../styles/service-description.scss';

function ServiceDetailsRedirect() {

  React.useEffect(() => {
    window.location.href = "https://mioo.cc/sv/cykelverkstad/"
  }, []);

  return <div></div>
}

export default ServiceDetailsRedirect;
